import { Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';

export const MemberRegistrySettingsWrapper = () => {
  const { t } = useTranslation(['settings']);
  const { currentUser } = useGlobals();

  const hasSettingsPermission = getPermission(currentUser, PermissionEnum.MemberRegSettingsRead);
  const hasWebFormPermission = getPermission(currentUser, PermissionEnum.MemberRegWebFormRead);

  const tabs: PageTabItem[] = [
    ...(hasSettingsPermission
      ? [
          {
            label: 'settings:memberRegistry.tabGeneral',
            route: RoutesEnum.MemberRegistrySettingsGeneral,
          },
          {
            label: 'settings:memberRegistry.tabForms',
            route: RoutesEnum.MemberRegistrySettingsForms,
          },
        ]
      : []),
    ...(hasWebFormPermission
      ? [
          {
            label: 'settings:memberRegistry.tabWebForms',
            route: RoutesEnum.MemberRegistrySettingsWebForms,
          },
        ]
      : []),
    ...(hasSettingsPermission
      ? [
          {
            label: 'settings:memberRegistry.tabMyPage',
            route: RoutesEnum.MemberRegistrySettingsMyPage,
          },
        ]
      : []),
    {
      label: 'settings:memberRegistry.tabProfiles',
      route: RoutesEnum.MemberRegistrySettingsProfiles,
    },
  ];

  const location = useLocation();

  // Redirect från basrouten till första tillgängliga fliken
  if (location.pathname === RoutesEnum.MemberRegistrySettings || location.pathname === `${RoutesEnum.MemberRegistrySettings}/`) {
    return <Navigate to={tabs[0].route} replace />;
  }

  return (
    <GridWrapper>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
        <MainContentHeader title={t('settings:memberRegistry.pageTitle')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <PageTabNavigation pageTabs={tabs} />
          <Outlet />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
